<div id="enrollment-agreement">
  <div class="page1 p-3">

    <div class="d-flex align-items-start justify-content-between mb-3">
      <h3 class="fw-bold mb-0">STUDENT ENROLLMENT AGREEMENT</h3>
      <img style="max-width:160px;" src="assets/images/AMDCBlackHorizontalJPG.jpg" />
    </div>

    <!-- Student Information -->
    <div class="d-flex border-bottom pb-1 mb-1">
      <span class="fw-bold me-2">Name(s):</span>
      <span>{{ entityData?.['field_student']?.['title'] || '' }}</span>
    </div>
    <div class="d-flex gap-4 border-bottom pb-1 mb-1">
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Address:</span>
        <span>{{ primaryContact?.field_address?.address_line1 || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">City:</span>
        <span>{{ primaryContact?.field_address?.locality || '' }}</span>
      </div>
    </div>
    <div class="d-flex gap-4 border-bottom pb-1 mb-1">
      <div>
        <span class="fw-bold me-1">Prov:</span>
        <span>{{ primaryContact?.field_address?.administrative_area || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">Postal Code:</span>
        <span>{{ primaryContact?.field_address?.postal_code || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Phone (H):</span>
        <span></span>
      </div>
    </div>
    <div class="d-flex gap-4 border-bottom pb-1 mb-2">
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Email:</span>
        <span>{{ primaryContact?.field_email || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Phone (C):</span>
        <span>{{ primaryContact?.field_cell_phone || '' }}</span>
      </div>
    </div>
    <div class="d-flex align-items-center gap-2 small mb-2">
      <span class="fw-bold">Best way to reach you:</span>
      <span>Phone: (H) <span class="border border-dark d-inline-block align-middle" style="width:12px;height:12px;"></span></span>
      <span>(C) <span class="border border-dark d-inline-block align-middle" style="width:12px;height:12px;"></span></span>
      <span>Email: <span class="border border-dark d-inline-block align-middle" style="width:12px;height:12px;"></span></span>
    </div>

    <!-- Enrollment type -->
    <div class="d-flex align-items-center gap-3 mb-2 small border-top pt-2">
      <span class="fw-bold">Type of Enrollment (check):</span>
      <span class="d-flex align-items-center">Original <span class="border border-dark d-inline-block ms-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.original ? '#000' : '#fff'"></span></span>
      <span class="d-flex align-items-center">Extension <span class="border border-dark d-inline-block ms-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.extension ? '#000' : '#fff'"></span></span>
      <span class="d-flex align-items-center">Renewal <span class="border border-dark d-inline-block ms-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.renewal ? '#000' : '#fff'"></span></span>
      <span class="d-flex align-items-center">Service <span class="border border-dark d-inline-block ms-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.service ? '#000' : '#fff'"></span></span>
    </div>

    <p class="small fw-bold text-center mb-2">The Student agrees to purchase, and the owner of Arthur Murray agrees to provide the following course of dance instruction and/or services on the following terms and conditions.</p>

    <!-- Front-page terms -->
    <div class="border p-2 small mb-3">
      <p class="mb-1">&#10063; All sessions are of a 40-minute duration and are to be purchased on a pre-paid basis.</p>
      <p class="mb-1">&#10063; Student acknowledges to the School that they are physically and financially able to participate in this course of instruction and/or service, has read and fully understands the terms of this agreement, has signed the agreement voluntarily, and hereby acknowledges receipt of a fully executed copy.</p>
      <p class="mb-0">&#10063; Student's rights under this agreement are personal in nature and may not be sold, assigned or transferred to any other person. In the event of a Student's death or physical disability, the Student or their representatives may sell, donate, or transfer the remaining sessions and/or services to any persons or charity subject to School's approval.</p>
    </div>

    <!-- Lesson table -->
    <table class="table table-bordered text-center small mb-1">
      <tr>
        <td class="fw-bold" colspan="3">COURSE</td>
        <td class="fw-bold" rowspan="2">TUITION</td>
        <td class="fw-bold" rowspan="2">DISCOUNT OR CREDIT</td>
        <td class="fw-bold" rowspan="2">{{ taxLabel }}<ng-container *ngIf="this.studioInformationConfig?.field_studio_vat_number?.[0]?.value"><br><span class="fw-normal" style="font-size:0.65rem;">No. {{ this.studioInformationConfig?.field_studio_vat_number?.[0]?.value }}</span></ng-container></td>
        <td class="fw-bold" rowspan="2">BALANCE DUE</td>
      </tr>
      <tr>
        <td class="fw-bold">PRIVATE SESSIONS</td>
        <td class="fw-bold">GROUP SESSIONS</td>
        <td class="fw-bold">PRACTICE PARTIES</td>
      </tr>
      <tr>
        <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
        <td></td>
        <td></td>
        <td>${{ getOriginalPackageCost() | number:'1.2-2' }}</td>
        <td>${{ getDiscount() | number:'1.2-2' }}</td>
        <td>${{ getGstAmount() | number:'1.2-2' }}</td>
        <td>${{ calculateTotalTuition() | number:'1.2-2' }}</td>
      </tr>
      <tr>
        <td class="fw-bold text-start" colspan="5">TYPES OF SERVICE(S): <span class="fw-normal">{{ getPackageName() }}<ng-container *ngIf="getNotes()"> &mdash; <span class="fst-italic">{{ getNotes() }}</span></ng-container></span></td>
        <td class="fw-bold text-start" colspan="2">Total Tuition/Cost: <span class="fw-normal">${{ calculateTotalTuition() | number:'1.2-2' }}</span></td>
      </tr>
    </table>

    <p class="small fw-bold fst-italic text-center mb-2">The expiry date of this agreement is <span class="border-bottom px-3">two years as of the date below</span></p>

    <!-- Payment terms -->
    <div class="border border-dark p-2 mb-3">
      <p class="small fw-bold text-center text-decoration-underline mb-1">IMPORTANT</p>

      <p class="small text-center mb-1">I hereby agree to pay Arthur Murray
        <span class="fw-bold border-bottom px-3">${{ getFirstPaymentToday() | number:'1.2-2' }}</span> today as the 1<sup>st</sup> payment
        <ng-container *ngIf="monthlyAmount !== null"> and authorize them to charge to my account the amount of
          <span class="fw-bold border-bottom px-3">${{ monthlyAmount | number:'1.2-2' }}</span> on the
          <span class="fw-bold border-bottom px-2">{{ monthlyChargeDay || '____' }}</span> day of each month starting on
          <span class="fw-bold border-bottom px-3">{{ monthlyStartDate ? (monthlyStartDate | date) : '' }}</span> until paid in full</ng-container>.</p>

      <div *ngIf="isInstallmentAgreement && !isMonthlyPlan && allPaymentRows.length > 1" class="mb-2" style="max-width:420px;">
        <ng-container *ngIf="areAllPaymentAmountsSame(); else detailedPayments">
          <table class="table table-bordered text-center small mb-0">
            <tr><th>Number of Payments</th><th>Amount of Payments</th><th>Payments Due</th></tr>
            <tr>
              <td>{{ allPaymentRows.length }}</td>
              <td>${{ allPaymentRows[0].amount | number:'1.2-2' }}</td>
              <td>{{ firstPaymentDate ? (firstPaymentDate | date) : 'Not specified' }}</td>
            </tr>
          </table>
        </ng-container>
        <ng-template #detailedPayments>
          <table class="table table-bordered text-center small mb-0">
            <tr><th>Payment #</th><th>Amount</th><th>Due Date</th></tr>
            <tr *ngFor="let payment of allPaymentRows; let i = index">
              <td>{{ i + 1 }}</td>
              <td>${{ payment.amount | number:'1.2-2' }}</td>
              <td>{{ payment.date ? (payment.date | date) : '' }}</td>
            </tr>
          </table>
        </ng-template>
      </div>

      <p class="small text-center mb-0">I understand I may cancel or suspend this agreement at any time provided I give the school's administration one month's written notice and understand that I am responsible for the next payment if notice is within a month of such payment.</p>
    </div>

    <!-- Studio box + signatures -->
    <div class="row">
      <div class="col-6">
        <div class="text-center small mb-2">
          <p class="fw-bold mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.organization || this.studioInformationConfig?.field_studio_display_name?.[0]?.value || '' }}<ng-container *ngIf="this.studioInformationConfig?.field_studio_address?.[0]?.organization"> dba {{ this.studioInformationConfig?.field_studio_display_name?.[0]?.value || 'Arthur Murray Dance Centre' }}</ng-container></p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }},</p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }},
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }},
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}</p>
        </div>
        <ng-container *ngIf="displaySigned">
          <p class="small mb-0">Signed:</p>
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
          </div>
          <small class="text-muted fst-italic">Studio Representative</small>
        </ng-container>
      </div>
      <div class="col-6" *ngIf="displaySigned">
        <p class="small mb-1">Signed this DATE: <span class="fw-bold">{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
        <p class="small text-center mb-2">THE STUDENT HEREBY ACKNOWLEDGES THAT<br>They have read the terms and conditions above and on the back of this agreement.</p>
        <div class="border-bottom" style="height:30px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
        <small class="text-muted fst-italic">Student's Signature</small>
      </div>
    </div>

  </div>

  <!-- The School's/Student's Rights and Obligations back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the other templates. -->
</div>
